import React, { createContext, useContext, useMemo, useState } from 'react';

const EMPTY_ASSESSMENT_CONTEXT = {
    framework: null,
    domain: null,
    control: null,
    questions: [],
    progress: null,
};

const AssessmentAIContext = createContext({
    assessmentContext: EMPTY_ASSESSMENT_CONTEXT,
    setAssessmentContext: () => {},
});

export const AssessmentAIProvider = ({ children }) => {
    const [assessmentContext, setAssessmentContext] = useState(EMPTY_ASSESSMENT_CONTEXT);
    const value = useMemo(
        () => ({ assessmentContext, setAssessmentContext }),
        [assessmentContext]
    );

    return (
        <AssessmentAIContext.Provider value={value}>
            {children}
        </AssessmentAIContext.Provider>
    );
};

export const useAssessmentAI = () => useContext(AssessmentAIContext);

